import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import ExpensecateList from "../ExpensecateList";

function AdminExpenseList(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={6}
        childrenPage={<ExpensecateList/>}/>
        </DataContext.Provider>
    )
}

export default AdminExpenseList;